/**
 * 工单月报搜索组件
 */

import { useState, useEffect } from "react";
import { ConfigProvider, Row, Col, Modal, DatePicker } from "antd";

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import { LastMonth, rootReactDom } from '../../incs/FunHelper.js';

import WOMREntity from './WOMREntity';

const { MonthPicker } = DatePicker;

const MRSearch = (props) => {

    const [open, setOpen] = useState(false);
    const [month, setMonth] = useState(LastMonth());


    useEffect(() => {
        setOpen(true);
    }, [props]);

    const cancel = () => {
        setOpen(false);
        setMonth(LastMonth());
    }

    /***
     * 工单月报s实体
     */

    const ok = () => {
        rootReactDom && rootReactDom.render(
            <WOMREntity
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                month={month}
                record={props.record}
            />);
    }
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            <Modal
                closable={false}
                open={open}
                keyboard={true}
                width={400}
                onOk={ok}
                onCancel={cancel}
                okText="确定"
                cancelText="取消"
            >
                <Row>
                    <Col span={24}>选择月份</Col>
                    <Col span={24}>
                        <MonthPicker
                            style={{ width: "100%" }}
                            placeholder='请选择月份'
                            onChange={(_, dateString) => setMonth(dateString)}
                            value={dayjs(month, 'YYYY-MM')}
                            locale={locale}
                        />
                    </Col>
                </Row>
            </Modal>
        </ConfigProvider>
    );
}

export default MRSearch;